<ion-header *ngIf="isMobileView">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="onCloseClick()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="isMobileView">
  
  <ion-list class="p-2">
    <ion-item
      lines="none"
      button
      [ngClass]="{ active: isAllActive }"
      (click)="onMenuClick($event, 'All')"
    >
      <ion-label class="ion-text-center ion-text-md-end">All</ion-label>
      <ion-badge
        color="light"
        slot="end"
        [innerText]="totalCount"
      ></ion-badge>
    </ion-item>
    <ion-item
      lines="none"
      *ngFor="let menu of menus; let i = index"
      (click)="onMenuClick($event, menu)"
      button
      [ngClass]="{ active: value?.menuId === menu.menuId && !isAllActive }"
    >
      <ion-label class="ion-text-center ion-text-md-end">
        <span [innerText]="menu.menuName"></span>
        <!-- <span>&nbsp;(</span> -->
        <!-- <span>)</span> -->
      </ion-label>
      <ion-badge
        color="light"
        slot="end"
        *ngIf="menu.itemsMappings"
        [innerText]="menu.itemsMappings.length"
      ></ion-badge>
    </ion-item>
  </ion-list>

</ion-content>

<ion-list class="p-2" *ngIf="!isMobileView">
  <ion-item
    lines="none"
    button
    [ngClass]="{ active: isAllActive }"
    (click)="onMenuClick($event, 'All')"
  >
    <ion-label class="ion-text-center ion-text-md-end">All</ion-label>
    <ion-badge
      color="light"
      slot="end"
      [innerText]="totalCount"
    ></ion-badge>
  </ion-item>
  <ion-item
    lines="none"
    *ngFor="let menu of menus; let i = index"
    (click)="onMenuClick($event, menu)"
    button
    [ngClass]="{ active: value?.menuId === menu.menuId && !isAllActive }"
  >
    <ion-label class="ion-text-center ion-text-md-end">
      <span [innerText]="menu.menuName"></span>
      <!-- <span>&nbsp;(</span> -->
      <!-- <span>)</span> -->
    </ion-label>
    <ion-badge
      color="light"
      slot="end"
      *ngIf="menu.itemsMappings"
      [innerText]="menu.itemsMappings.length"
    ></ion-badge>
  </ion-item>
</ion-list>